import {
    Autocomplete,
    Box,
    Button,
    FormHelperText,
    Grid,
    IconButton,
    Stack,
    TextField,
  } from "@mui/material";
  import { Button as UploadButton } from "@mui/material";
  import DeleteIcon from "@mui/icons-material/Delete";
  import CloudUploadIcon from "@mui/icons-material/CloudUpload";
  import React, { useEffect, useState } from "react";
  import { FormButton } from "../../Components/UiElements/UiElements";
  import { useLocation, useNavigate, useParams } from "react-router-dom";
  import { makeStyles } from "@mui/styles";
  // import DeleteIcon from "@mui/icons-material/Delete";
  import {
    hideLoading,
    showLoading,
    useLoadingDispatch,
  } from "../../context/loadingContext";
  import AuthService from "../../Components/auth/AuthService";
  import config, { env } from "../../Components/config";
  import moment from "moment";
  import qs from "query-string";
  import Message from "../../Components/common/Message";
  import { DatePickerField } from "../../Components/InputFields/InputFields";
  import {
    Divider,
    Popconfirm,
    Skeleton,
    Button as AntButton,
    Row,
    Col,
    Input,
    Radio,
    Image,
    Tooltip,
  } from "antd";
  import { ArrowLeftOutlined, CloseOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons";
  import './Accident.css'
import { DriverTypes } from "../../Components/common/Constants";
import { useDispatch, useSelector } from "react-redux";
import { extractOriginalFileName, getNewFileName } from "../../Components/common/CommonFun";
  
  const useStyles = makeStyles((theme) => ({
    dateField: {
      width: "60%",
      height: "37px",
    },
    dataSheet: {
      "& .example-custom-input": {
        width: "100% !important",
      },
      "& .react-datepicker-wrapper": {
        width: "100% !important",
      },
    },
    inputText: {
      ".MuiTextField-root": {
        width: '200px'
      }
    }
  }));
  
  const Auth = new AuthService();
  
  const Index = () => {
    const { pinValidity } = useSelector((state) => state?.AppState?.driverData);
    const { selectedRoute } = useSelector((state) => state?.AppState?.driverData);
    const { driverRoutes } = useSelector((state) => state?.AppState?.driverData);
    const selectedRouteData = driverRoutes.find((route) => route.id === selectedRoute);
    const deliveryDate = localStorage.getItem("delivery_date");

    const securityPinExists = localStorage.getItem("securityPin");
    const policyHolder = 'Magna Foodservice Ltd'
    const policyNumber = 'A20268 Direct Commercials Ltd'
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const classes = useStyles();
    const params = useParams();
    const { TextArea } = Input;
    const [recordId, setRecordId] = React.useState(null);
    var layoutDispatch = useLoadingDispatch();
    //Accident States
    const [allVehicles, setAllVehicle] = React.useState([]);
    const [allDrivers, setAllDrivers] = React.useState([]);
    const [accidentDate, setAccidentDate] = useState("");
    const [loadMessage, setLoadMessage] = React.useState("");
    const [type, setType] = React.useState("");
    const [notes, setNotes] = React.useState("");

    const location = useLocation();
    const accidentReportData = location?.state?.accidentReportData;

    const [selfDetails, setSelfDetails] = React.useState({
        policy_holder: "",
        policy_number: "",
        driver: "",
        vehicle: "",
        contact: "",
        driver_type: "",
        accidentLocation: ""
      });

      const [otherPartyDetails, setOtherPartyDetails] = React.useState({
        email: "",
        policy_number: "",
        name: "",
        vehicle: "",
        contact: "",
        address: "",
        insurer_name: "",
        damage: ""
      });

      const [witnessDetails, setWitnessDetails] = React.useState({
        witness_name_1: "",
        witness_contact_number_1: "",
        witness_address_1: "",
        witness_name_2: "",
        witness_contact_number_2: "",
        witness_address_2: "",
        witness_name_3: "",
        witness_contact_number_3: "",
        witness_address_3: "",
      });

      const [anyInjury, setAnyInjury] = React.useState({
        isInjured: 2,
        injuryNotes: "",
      });

      const [anyDamage, setAnyDamage] = React.useState({
        isDamaged: 2,
        damageNotes: "",
      });

      const [police, setPolice] = React.useState({
        isPolice: 2,
        policeNotes: "",
      });

      const [bridgeStrike, setBridgeStrike] = React.useState({
    isStrike: 2,
    strikeNotes: "",
  });

      const [errors, setErrors] = useState({
        accidentDate: "",
        contactNumber: "",
        driverType: "",
        otherName: "",
        otherVehicle: "",
        otherContact: "",
        otherPolicy: "",
        otherEmail: "",
        otherInsurer: "",
        otherAddress: "",
        otherDamage: "",
        injuryNotes: "",
        damageNotes: "",
        policeNotes: "",
        strikeNotes: "",
        notes: "",
        fault: '',
        witnessOneName: "",
        witnessOneContact: "",
        witnessOneAddress: "",
        accidentLocation: ""

      });

  const [files, setFiles] = React.useState([]); 
  const [currentItemFiles, setCurrentItemFiles] = useState([]);
  const [deletedFiles, setDeletedFiles] = useState([]);

  const [filesBridge, setFilesBridge] = useState([]);
  const [currentItemFilesBridge, setCurrentItemFilesBridge] = useState([]);
  
  const handleSubmitImageBridge = (e) => {
    e.preventDefault();
    let acceptedFiles = e.target.files;

    for (let file of acceptedFiles) {
      const newFileName = getNewFileName(file.name);
      setLoadMessage("");
      setFilesBridge((prevFiles) => [
        ...prevFiles,
        {
          name: newFileName,
          display_name: newFileName,
          file: file,
          ContentType: file.type,
        },
      ]);
      setCurrentItemFilesBridge((prevFiles) => [...prevFiles, newFileName]);
    }
  };

  const handleSubmitImage = (e) => {
    e.preventDefault();
    let acceptedFiles = e.target.files;

    for (let file of acceptedFiles) {
      const randomString = Math.random().toString(36).substring(2, 10);
      const newFileName = `${file.name.split(".")[0]}-${randomString}.${file.name.split(".")[1]
        }`;
      setLoadMessage("");
      setFiles((prevFiles) => [
        ...prevFiles,
        {
          name: newFileName,
          display_name: newFileName,
          file: file,
          ContentType: file.type,
        },
      ]);
      setCurrentItemFiles((prevFiles) => [...prevFiles, newFileName]);
    }
  };

  const getUploadUrl = async (file, ID) => {
    const params = {
      bucket: config.tms_uploads_bucket,
      ContentType: file.file.type,
      Key: config.env + "/accidents/" + ID + "/" + file.name,
    };
    const response = await fetch(
      `${config.domain}/generate-put-url?${qs.stringify(params)}`,
      {
        headers: {
          "Content-Type": params.ContentType,
        },
      }
    );
    return response.json();
  };

  const uploadFileToS3 = async (uploadUrl, file, contentType) => {
    const response = await fetch(uploadUrl.putURL, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": contentType,
      },
    });
    if (response.status !== 200) {
      throw new Error("File upload failed.");
    }
  };

  const handleDeleteCurrentFile = (itemToDelete) => {
    setCurrentItemFiles(
      currentItemFiles.filter((item) => item !== itemToDelete)
    );
    if (!deletedFiles.includes(itemToDelete)) {
      setDeletedFiles((prevDeletedFiles) => [
        ...prevDeletedFiles,
        itemToDelete,
      ]);
    }
  };

  const deleteNormalFilesBridge = (fileName) => {
    const updatedFiles = filesBridge?.filter((file) => file.name !== fileName);
    setFilesBridge(updatedFiles);
    setCurrentItemFilesBridge(currentItemFiles?.filter((item) => item !== fileName));
  };

   const handleDeleteCurrentFileBridge = (itemToDelete) => {
    setCurrentItemFilesBridge(
      currentItemFilesBridge.filter((item) => item !== itemToDelete)
    );
  };

  const handleDeleteFile = (fileName) => {
    const updatedFiles = files?.filter((file) => file.name !== fileName);
    setFiles(updatedFiles);
    setCurrentItemFiles(currentItemFiles?.filter((item) => item !== fileName));
  };

  console.log(files);
    

    React.useEffect( () => {
        const fetchData = async ()=> {
        let rand = Math.random() * 50;
        let str = " ";
        for (let i = 0; i < rand; i++) {
         str += " ";
        }
          showLoading(layoutDispatch);
          try {
          const driverData = await Auth.fetch('/driver/drivers')
            if(driverData?.ack){
                setAllDrivers(driverData?.drivers)
            const vehicleData = await Auth.fetch('/vehicle/vehicles')
            if(vehicleData.ack){
                setAllVehicle(vehicleData?.vehicles)
                showLoading(layoutDispatch);
                const res = await Auth.fetch(`/accident/accident-driver?route_status_id=${selectedRoute}`);
                if (res?.ack) {
                    setRecordId(res?.accident?.id || null)
                    setAccidentDate(new Date(res?.accident?.accident_date));
                    setNotes(res?.accident?.notes)
                    const driverType = DriverTypes.find((obj) => obj.id == res?.accident?.agency_driver);
                      const newDriver = driverData.drivers.find(
                        (obj) => obj.id == res?.accident?.driver_id
                      );
                      const newVehicle = vehicleData?.vehicles.find(
                        (obj) => obj.id == res?.accident?.vehicle_id
                      );
                      setSelfDetails((prev)=>({
                        ...prev,
                        driver_type: driverType,
                        driver: newDriver,
                        vehicle: newVehicle,
                        contact: res?.accident?.contact_number,
                        accidentLocation: res?.accident?.accident_location,

                      }));
                      setOtherPartyDetails((prev)=>({
                        ...prev,
                        name: res?.accident?.other_party_name,
                        vehicle: res?.accident?.other_party_registration_no,
                        contact: res?.accident?.other_party_contact_number,
                        policy_number: res?.accident?.other_party_policy_number,
                        email: res?.accident?.other_party_email,
                        insurer_name: res?.accident?.other_party_insurer,
                        address: res?.accident?.other_party_address,
                        damage: res?.accident?.other_party_impact,
                      }))
                      setWitnessDetails((prev)=>({
                        ...prev,
                        witness_name_1: res?.accident?.witness_name_1,
                        witness_contact_number_1: res?.accident?.witness_contact_number_1,
                        witness_address_1: res?.accident?.witness_address_1,
                        witness_name_2: res?.accident?.witness_name_2,
                        witness_contact_number_2: res?.accident?.witness_contact_number_2,
                        witness_address_2: res?.accident?.witness_address_2,
                        witness_name_3: res?.accident?.witness_name_3,
                        witness_contact_number_3: res?.accident?.witness_contact_number_3,
                        witness_address_3: res?.accident?.witness_address_3
                      }))
                      setAnyInjury((prev)=>({
                        ...prev,
                        isInjured: res?.accident?.injured,
                        injuryNotes: res?.accident?.injured_notes,
                      }))
                      setAnyDamage((prev)=>({
                        ...prev,
                        isDamaged: res?.accident?.damage,
                        damageNotes: res?.accident?.damage_notes,
                      }))
                      setPolice((prev)=>({
                        ...prev,
                        isPolice: res?.accident?.police_involved,
                        policeNotes: res?.accident?.police_notes,
                      }))
                      setBridgeStrike((prev) => ({
                      ...prev,
                      isStrike: res?.accident?.bridge_strike,
                      strikeNotes: res?.accident?.bridge_strike_notes,
                    }))
                    setCurrentItemFilesBridge(res?.accident?.bridge_strike_files ? JSON.parse(res?.accident?.bridge_strike_files) : []);
                    
                      setCurrentItemFiles(JSON.parse(res?.accident.driver_files) || [])
                  } else {
                    setAccidentDate(new Date());
                    const driverObj = driverData?.drivers.find((obj) => obj.id == accidentReportData?.driver_id);
                    const vehicleObj = vehicleData?.vehicles.find((obj) => obj.id == accidentReportData?.vehicle_id);
                    setSelfDetails((prev)=>({
                        ...prev,
                        driver: driverObj,
                        vehicle: vehicleObj
                    }))
                }
            } else {
                setType('error')
                setLoadMessage(vehicleData?.message + str)
            }

            } else {
                setType('error')
                setLoadMessage(driverData?.message + str)
            }
          } catch (err) {
            console.log(err);
          } finally {
            hideLoading(layoutDispatch);
          }
        }
        fetchData()
      }, []);

      console.log('recordId', recordId);
      
  
      const uploadWithRetry = async (uploadUrl, file, mime, maxAttempts = 3) => {
  let attempt = 0;

  while (attempt < maxAttempts) {
    try {
      return await uploadFileToS3(uploadUrl, file, mime);
    } catch (err) {
      attempt++;
      console.warn(`Upload attempt ${attempt} failed for`, file?.name);

      if (attempt >= maxAttempts) {
        console.error("Upload failed after retries:", file?.name);
        throw err;
      }

      // Wait before retrying
      await new Promise((res) => setTimeout(res, 500));
    }
  }
};
  
    const handleSubmit = async (e) => {
        e.preventDefault();
        const rand = Math.random() * 50;
        const str = " ".repeat(rand);
        const isEmptyOrUndefined = (value) => value === '' || value === null || value === undefined;

        const checkAndSetError = (condition, key, message) => {
          if (condition) {
            setErrors((prevErrors) => ({ ...prevErrors, [key]: message }));
            setType('error');
            setLoadMessage(`${message}${str}`);
            return true;
          }
          return false;
        };
    
        if (
          checkAndSetError(isEmptyOrUndefined(accidentDate), 'accidentDate', 'Accident Date is required') ||
          // checkAndSetError(isEmptyOrUndefined(selfDetails?.contact), 'contactNumber', 'Contact number is required') ||
          checkAndSetError(isEmptyOrUndefined(selfDetails?.driver_type), 'driverType', 'Agency Driver YES/No ? is required') ||
          checkAndSetError(isEmptyOrUndefined(selfDetails?.accidentLocation), 'accidentLocation', 'Accident Location is required') ||
          checkAndSetError(isEmptyOrUndefined(otherPartyDetails?.name), 'otherName', 'Other Party Name is required') ||
          checkAndSetError(isEmptyOrUndefined(otherPartyDetails?.vehicle), 'otherVehicle', 'Other Party Registration No. is required') ||
          checkAndSetError(isEmptyOrUndefined(otherPartyDetails?.contact), 'otherContact', 'Other Party Contact Number is required') ||
          // checkAndSetError(isEmptyOrUndefined(otherPartyDetails?.policy_number), 'otherPolicy', 'Other Party Policy Number is required') ||
          checkAndSetError(isEmptyOrUndefined(otherPartyDetails?.email), 'otherEmail', 'Other Party email is required') ||
          // checkAndSetError(isEmptyOrUndefined(otherPartyDetails?.insurer_name), 'otherInsurer', 'Other Party Insurer Name is required') ||
          checkAndSetError(isEmptyOrUndefined(otherPartyDetails?.address), 'otherAddress', 'Other Party Address is required') ||
          checkAndSetError(isEmptyOrUndefined(otherPartyDetails?.damage), 'otherDamage', 'Damage or Point of impact is required') ||
          checkAndSetError(isEmptyOrUndefined(anyInjury?.injuryNotes), 'injuryNotes', 'injury Notes are required') ||
          checkAndSetError(isEmptyOrUndefined(anyDamage?.damageNotes), 'damageNotes', 'Damage Notes are required') ||
          checkAndSetError(isEmptyOrUndefined(police?.policeNotes), 'policeNotes', 'Police Notes are required') ||
          checkAndSetError(isEmptyOrUndefined(witnessDetails?.witness_name_1), 'witnessOneName', 'Enter Witness 1 name') ||
          // checkAndSetError(isEmptyOrUndefined(witnessDetails?.witness_address_1), 'witnessOneAddress', 'Enter Witness 1 address') ||
          checkAndSetError(isEmptyOrUndefined(witnessDetails?.witness_contact_number_1), 'witnessOneContact', 'Enter Witness 1 contact')
        ) {
          return;
        }
    
      
        const dataToSend = {
          route_id: accidentReportData?.route_id,
          driver_id: selfDetails?.driver?.id,
          vehicle_id: selfDetails?.vehicle?.id,
          accident_date: moment(accidentDate).format("YYYY-MM-DD HH:mm"),
          policy_holder: policyHolder,
          policy_number: policyNumber,
          contact_number: selfDetails?.contact,
          accident_location: selfDetails?.accidentLocation,
          agency_driver: selfDetails?.driver_type?.id,
          other_party_name: otherPartyDetails?.name,
          other_party_registration_no: otherPartyDetails?.vehicle,
          other_party_contact_number: otherPartyDetails?.contact,
          other_party_policy_number: otherPartyDetails?.policy_number,
          other_party_email: otherPartyDetails?.email,
          other_party_insurer: otherPartyDetails?.insurer_name,
          other_party_address: otherPartyDetails?.address,
          other_party_impact: otherPartyDetails?.damage,
          injured: anyInjury?.isInjured,
          injured_notes: anyInjury?.injuryNotes,
          damage: anyDamage?.isDamaged,
          damage_notes: anyDamage?.damageNotes,
          police_involved: police?.isPolice,
          police_notes: police?.policeNotes,
          bridge_strike: bridgeStrike?.isStrike || "",
      bridge_strike_notes: bridgeStrike?.strikeNotes || "",
      bridge_strike_files: currentItemFilesBridge,
          notes: notes,
          witness_name_1: witnessDetails?.witness_name_1,
          witness_contact_number_1: witnessDetails?.witness_contact_number_1,
          witness_address_1: witnessDetails?.witness_address_1,
          witness_name_2: witnessDetails?.witness_name_2,
          witness_contact_number_2: witnessDetails?.witness_contact_number_2,
          witness_address_2: witnessDetails?.witness_address_2,
          witness_name_3: witnessDetails?.witness_name_3,
          witness_contact_number_3: witnessDetails?.witness_contact_number_3,
          witness_address_3: witnessDetails?.witness_address_3,
          route_status_id: selectedRoute, 
          driver_files: currentItemFiles
        };
      
        if (recordId != null) dataToSend.id = recordId;
        
        showLoading(layoutDispatch);
      
        try {
          const response = await Auth.fetch(`/accident/accident-driver`, {
            method: recordId != null ? "PUT" : "POST",
            body: JSON.stringify(dataToSend),
          });
      
          if (response?.ack) {
          const uploadPromises = [];
          const pushUpload = (f) => {
          uploadPromises.push(
          getUploadUrl(f, response?.record_id || recordId)
            .then((uploadUrl) =>
              uploadWithRetry(uploadUrl, f.file, f.file.type)
            )
            .catch((err) => {
              throw err;
            })
        );
      };
          // if (filesBridge.length > 0) {
          //     filesBridge.forEach((f) => {
          //       uploadPromises.push(
          //         getUploadUrl(f, response?.record_id || recordId)
          //           .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
          //           .catch(error => console.error("Error uploading file:", error))
          //       );
          //     });
          //   }
          //   if (files.length > 0) {
          //   files.forEach((f) => {
          //     uploadPromises.push(
          //       getUploadUrl(f, response?.record_id || recordId)
          //         .then(uploadUrl => uploadFileToS3(uploadUrl, f.file, f.file.type))
          //         .catch(error => console.error("Error uploading file:", error))
          //     );
          //   });
          // }
          // await Promise.all(uploadPromises);
          filesBridge.forEach(pushUpload);
          files.forEach(pushUpload);
           try {
        await Promise.all(uploadPromises);
      } catch (error) {
        hideLoading(layoutDispatch);
        setType("error");
        setLoadMessage("Some files failed to upload. Please try again.");
        return;
      }
          setType('success');
            setLoadMessage(response.message + str);
            navigate('/routes');

            // const uploadPromises = files.map(async (f) => {
            //   try {
            //     const uploadUrl = await getUploadUrl(f, response?.record_id || recordId);
            //     await uploadFileToS3(uploadUrl, f.file, f.file.type);
            //   } catch (error) {
            //     setLoadMessage("Error uploading file:");
            //     setType("error");
            //     console.error("Error uploading file:", error);
            //   }
            // });
            // Promise.all(uploadPromises).then(() => {
            // setType('success');
            // setLoadMessage(response.message + str);
            // navigate('/routes');
            // });

            const emailPayload = {
              driver_name: selectedRouteData?.driver_name,
              route_name: selectedRouteData?.route,
              accident_id: response?.record_id,
              accident_date: accidentDate, 
              route_date: deliveryDate,
              bridge_strike: bridgeStrike?.isStrike,
              action: "ADD",
              subject: `Magna TMS - Accident Report - ${selectedRouteData?.driver_name} - ${selectedRouteData?.route} ` ,
            };

            if(recordId == null) {
              // try {
              //   const EmailApiResponse = await fetch("https://tmsemail.api-magnafoodservice.co.uk/api/email/accidents", {
              //     method: "POST",
              //     headers: {
              //       Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAZ21haWwuY29tIiwidXNlcl9pZCI6MSwiaWF0IjoxNzI4NDE0NjIzLCJhdWQiOiJodHRwczovL3d3dy5tYWduYWZvb2RzZXJ2aWNlLmNvLnVrLyIsImlzcyI6Ik1hZ25hIEZvb2QgU2VydmljZSIsInN1YiI6Im5vb3JAZ21haWwuY29tIn0.fb--ERLcBgLhrec6Ed_rAR_uGiBWyFdLN-4fYjjdhjw411DODxyg058A7VVQuLAgD5A8OEa-9jOar0eOTqZk3WGnP8mhh_Tx0smCmiVNY73Odn0x0KZgVyx1yf4W6nEzAHJImmXwzbnPBTIVww7CG2a47GZ8M_XQxFJNhovOnIAEoIZdFz989QdyS_8UpTVIr1UV6nbpZ01ZNuHlU-ZBxJ9zPez1bD7Q9U8Gg59AeJsr3vp6XPDuWmW0C2G3Z3YO-5jT7e1S-lFNg7_8YTH5ju7RWlvdjOJ8lGIiQAVF4aRMXIJh3HHPYBdUWugj7Zb0ZF8F4rz8sR4zNgqEUXJtPQ",
              //       "Content-Type": "application/json"
              //     }, 
              //     body: JSON.stringify(emailPayload)
              //   });

    
              //   if (EmailApiResponse.ok === true) {
              //     setLoadMessage("Email sent " + str)
              //     setType('success')
              //   } else {
              //     setLoadMessage("Email Sendind Failure" + str)
              //     setType('error')
              //   }
    
              // } catch (err) {
              //   console.log(err);
              // }
              if (env === "prod") {
                fetch("https://tmsemail.api-magnafoodservice.co.uk/api/email/accidents", {
                  method: "POST",
                  headers: {
                    Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAZ21haWwuY29tIiwidXNlcl9pZCI6MSwiaWF0IjoxNzI4NDE0NjIzLCJhdWQiOiJodHRwczovL3d3dy5tYWduYWZvb2RzZXJ2aWNlLmNvLnVrLyIsImlzcyI6Ik1hZ25hIEZvb2QgU2VydmljZSIsInN1YiI6Im5vb3JAZ21haWwuY29tIn0.fb--ERLcBgLhrec6Ed_rAR_uGiBWyFdLN-4fYjjdhjw411DODxyg058A7VVQuLAgD5A8OEa-9jOar0eOTqZk3WGnP8mhh_Tx0smCmiVNY73Odn0x0KZgVyx1yf4W6nEzAHJImmXwzbnPBTIVww7CG2a47GZ8M_XQxFJNhovOnIAEoIZdFz989QdyS_8UpTVIr1UV6nbpZ01ZNuHlU-ZBxJ9zPez1bD7Q9U8Gg59AeJsr3vp6XPDuWmW0C2G3Z3YO-5jT7e1S-lFNg7_8YTH5ju7RWlvdjOJ8lGIiQAVF4aRMXIJh3HHPYBdUWugj7Zb0ZF8F4rz8sR4zNgqEUXJtPQ",
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(emailPayload),
                }).catch((err) => console.error("Error sending email:", err)); 
              } else if (env === "dev") {
                
                fetch("http://localhost:7420/api/email/accidents", {
                  method: "POST",
                  headers: {
                    Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAZ21haWwuY29tIiwidXNlcl9pZCI6MSwiaWF0IjoxNzI3ODgwNDE0LCJleHAiOjE3NTk0MTY0MTQsImF1ZCI6Imh0dHBzOi8vd3d3Lm1hZ25hZm9vZHNlcnZpY2UuY28udWsvIiwiaXNzIjoiTWFnbmEgRm9vZCBTZXJ2aWNlIiwic3ViIjoibm9vckBnbWFpbC5jb20ifQ.Bidb4jyOqnI4JdF9o0WpcEqiGQDpxv47KZ2mFyhFhLwj0LSui0ukFFH889J3tdVs3A-8ah-rk5026bfhEpneyUzkPl0IEE1iTBt4rdmXnUytXQRY38AsSiMv_v0S1gFL0JJtMh2Odzh3JpPbALaqEhCX0P2Kvhy9jNeczzWL8-rYw9b9WVgVN_mBd8AcdzgbzbeVOPd9hDL24im5QXwd6wIT9hme3e-lyBvW24bEp-ozxwaujVAZrtdh8BoSTTD2lyn0nKHc7iErGFjhFvtIw2pzvtnorNzfWJ2hB2BABQ0JOruxnxVks7NbNAMyBhchQhGV5af6ssDAZ4YaKUeNpw",
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(emailPayload),
                }).catch((err) => console.error("Error sending email:", err));
              } else {
                  fetch("http://34.197.161.10:7420/api/email/accidents", {
                  method: "POST",
                  headers: {
                    Authorization: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAbWFnbmFmb29kc2VydmljZS5jby51ayIsInVzZXJfaWQiOjEsImlhdCI6MTczNTU1OTM3NywiYXVkIjoiaHR0cHM6Ly93d3cubWFnbmFmb29kc2VydmljZS5jby51ay8iLCJpc3MiOiJNYWduYSBGb29kIFNlcnZpY2UiLCJzdWIiOiJub29yQG1hZ25hZm9vZHNlcnZpY2UuY28udWsifQ.ZC9_oBo2jQAz9EKCn19KD17WzMaVQPjuUUWhSBfDPPnaqb18j4cILaJIJUYgVprjjAGIzxUBt4Ln7do3br5Ps1nzkShjVrptne_eop_rxqcJCHnaIlra0UQnFsiTBJ8V_5GanQAQIVbuKwFlcpqJCb5adCeE5OipBANSURekGyMXSeYos4dVjrZu7g7DD8sxCWkePVW_LhlndbytgdkazRmOkHNmnq5x9bnO16fMAAPm1nMVxluC5bGJzJqCYhmnO-UlV6ZpAdCACS0ZW7tylwc2foEtkLz7jUE8X7hHUGCYfRO2N7gMcqKqBYgbf6DV5HEgsDFoEoGlxGjERqGjCQ",
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify(emailPayload),
                }).catch((err) => console.error("Error sending email:", err));
              }
            }
            
          } else {
            setType('error');
            setLoadMessage(response.message + str);
          }
        } catch (err) {
          console.log(err);
          setType('error');
          setLoadMessage('An error occurred. Please try again.');
        } finally {
          hideLoading(layoutDispatch);
        }
      };

      if (!pinValidity) {
        localStorage.removeItem("DriverName");
        localStorage.removeItem("securityPin");
        localStorage.removeItem("driverRoutes");
        localStorage.removeItem("route_name");
        localStorage.removeItem("driver_id");
        navigate("/pin");
        localStorage.setItem('routeLocation', false)
        dispatch({ type: "RESET_STATE" });
      }
    
      if (!securityPinExists) {
        navigate("/pin");
        localStorage.removeItem("DriverName");
        localStorage.removeItem("driverRoutes");
        localStorage.removeItem("route_name");
        localStorage.removeItem("driver_id");
        localStorage.setItem('routeLocation', false)
        dispatch({ type: "RESET_STATE" });
      }
      
  
    return (
      <div>
        
        <Row style={{ display:"flex", justifyContent: 'start'}}>
        <AntButton size="large" icon={<ArrowLeftOutlined />} onClick={() => navigate("/routes")}>Back</AntButton>
        </Row>
        <Grid container rowSpacing={1} columnSpacing={1}>
          <Grid item xs={12}>
            <h2
              style={{ float: "left" }}
            >
              Magna Accident Form 
            </h2>
          </Grid>
          <Grid item xs={12} sm={8} md={6} lg={4} xl={4}>
            <Stack spacing={2}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: '10px'
                //   justifyContent: "space-between",
                }}
              >
                <span style={{ marginRight: '8px'}}>Accident Date<span style={{ color: "red", fontSize: "15px" }}>*</span>:</span>
                <DatePickerField
                  todayButton="Today"
                  dateFormat="dd-MM-yyyy HH:mm"
                  timeFormat="HH:mm"
                  showTimeSelect
                  selected={accidentDate}
                  onChange={(date) => {
                    setAccidentDate(date);
                  }}
                />
              </div>
            </Stack>
          </Grid>
          <div className="accident-box">
            <span className="accident-box-heading">
            Accident Details
            </span>
            <Row gutter={[16,16]}>
             <Col Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <TextField
                 fullWidth
                 id="policy_holder"
                 size="small"
                 label="Policy Holder"
                 variant="outlined"
                 disabled
                 value={policyHolder}
            />
            </Col>
            <Col Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <TextField
                 fullWidth
                 id="policy_number"
                 size="small"
                 label="Policy Number"
                 variant="outlined"
                 disabled
                 value={policyNumber}
            />
            </Col>
            <Col Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <Autocomplete
                    id="driver"
                    options={allDrivers}
                    getOptionLabel={(option) => option.driver_name ? option.driver_name : ''}
                    value={selfDetails?.driver}
                    onChange={(e, values) => {
                      setSelfDetails((prevDetails)=> ({
                        ...prevDetails,
                        driver: values
                      }))}}
                      disabled
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        label="Driver"
                        placeholder="Driver"
                        required
                      />
                    )}
                  />
            </Col>
            <Col Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <Autocomplete
                id="vehicle"
                options={allVehicles}
                getOptionLabel={(option) => option.registration_number ? option.registration_number : ''}
                value={selfDetails?.vehicle}
                onChange={(e, values) => {
                    setSelfDetails((prevDetails)=> ({
                      ...prevDetails,
                      vehicle: values
                    }))}}
                    disabled
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    label="Registration Number"
                    placeholder="Registration Number"
                    required
                  />
                )}
              />
            </Col>
            <Col Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <TextField
                 fullWidth
                 id="phone"
                 size="small"
                 label="Contact Number"
                 variant="outlined"
                 placeholder="Contact Number"
                 value={selfDetails?.contact}
                 onChange={(e) => {
                    setSelfDetails((prevDetails)=> ({
                      ...prevDetails,
                      contact: e.target.value
                    }))
                    setErrors((prevDetails)=> ({
                      ...prevDetails,
                      contactNumber: ''
                    }))
                }}
                error={errors?.contactNumber === "" ? false : true}
                helperText={errors?.contactNumber}
            />
            </Col>
            <Col Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <Autocomplete
                id="vehicle"
                options={DriverTypes}
                getOptionLabel={(option) => option.title ? option.title : ''}
                value={selfDetails?.driver_type}
                onChange={(e, values) => {
                    setSelfDetails((prevDetails)=> ({
                      ...prevDetails,
                      driver_type: values
                    }))
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      driverType: '',
                    }))
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    label="Agency Driver? YES / NO"
                    placeholder="Agency Driver? YES / NO"
                    required
                    error={errors?.driverType === "" ? false : true}
                    helperText={errors?.driverType}
                  />
                )}
              />
            </Col>
            <Col Col xs={24} sm={12} md={8} lg={8} xl={8}>
              <TextField
                fullWidth
                id="phone"
                size="small"
                label="Accident Location"
                required
                variant="outlined"
                placeholder="Accident Location"
                value={selfDetails?.accidentLocation}
                onChange={(e) => {
                  setSelfDetails((prevDetails) => ({
                    ...prevDetails,
                    accidentLocation: e.target.value
                  }))
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    accidentLocation: '',
                  }))
                }}
                error={errors?.accidentLocation === "" ? false : true}
                helperText={errors?.accidentLocation}
              />
            </Col>
            </Row>
          </div>
          <div className="accident-box" style={{ marginTop: '20px'}}>
            <span className="accident-box-heading">
            Other Party Details
            </span>
            <Row gutter={[16,16]}>
             <Col Col xs={24} sm={12} md={8} lg={8} xl={8}>
                <TextField
                 fullWidth
                 id="other_name"
                 size="small"
                 label="Name"
                 variant="outlined"
                 placeholder="Name"
                 value={otherPartyDetails?.name}
                 onChange={(e) => {
                    setOtherPartyDetails((prevDetails)=> ({
                      ...prevDetails,
                      name: e.target.value
                    }))
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      otherName: '',
                    }))
                }}
                required
                error={errors?.otherName === "" ? false : true}
                helperText={errors?.otherName}
            />
            </Col>
            <Col Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <TextField
                 fullWidth
                 id="other_vehicle"
                 size="small"
                 label="Registration Number"
                 variant="outlined"
                 placeholder="Registration Number"
                 value={otherPartyDetails?.vehicle}
                 onChange={(e) => {
                    setOtherPartyDetails((prevDetails)=> ({
                      ...prevDetails,
                      vehicle: e.target.value
                    }))
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      otherVehicle: '',
                    }))
                }}
                required
                error={errors?.otherVehicle === "" ? false : true}
                helperText={errors?.otherVehicle}
            />
            </Col>
            <Col Col xs={24} sm={12} md={8} lg={8} xl={8}>
              <TextField
                 fullWidth
                 id="other_phone"
                 size="small"
                 label="Contact Number"
                 variant="outlined"
                 placeholder="Contact Number"
                 value={otherPartyDetails?.contact}
                 onChange={(e) => {
                    setOtherPartyDetails((prevDetails)=> ({
                      ...prevDetails,
                      contact: e.target.value
                    }))
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      otherContact: '',
                    }))
                }}
                required
                error={errors?.otherContact === "" ? false : true}
                helperText={errors?.otherContact}
               />
            </Col>
            <Col Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <TextField
                 fullWidth
                 id="other_policy_no"
                 size="small"
                 label="Policy Number"
                 variant="outlined"
                 placeholder="Policy Number"
                 value={otherPartyDetails?.policy_number}
                 onChange={(e) => {
                    setOtherPartyDetails((prevDetails)=> ({
                      ...prevDetails,
                      policy_number: e.target.value
                    }))
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      otherPolicy: '',
                    }))
                }}
                error={errors?.otherPolicy === "" ? false : true}
                helperText={errors?.otherPolicy}
               />
            </Col>
            <Col Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <TextField
                 fullWidth
                 id="other_email"
                 size="small"
                 label="Email Address"
                 variant="outlined"
                 placeholder="Email Address"
                 value={otherPartyDetails?.email}
                 onChange={(e) => {
                    setOtherPartyDetails((prevDetails)=> ({
                      ...prevDetails,
                      email: e.target.value
                    }))
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      otherEmail: '',
                    }))
                }}
                required
                error={errors?.otherEmail === "" ? false : true}
                helperText={errors?.otherEmail}
               />
            </Col>
            <Col Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <TextField
                 fullWidth
                 id="other_insure_name"
                 size="small"
                 label="Insurer's Name"
                 variant="outlined"
                 placeholder="Insurer's Name"
                 value={otherPartyDetails?.insurer_name}
                 onChange={(e) => {
                    setOtherPartyDetails((prevDetails)=> ({
                      ...prevDetails,
                      insurer_name: e.target.value
                    }))
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      otherInsurer: '',
                    }))
                }}
                error={errors?.otherInsurer === "" ? false : true}
                helperText={errors?.otherInsurer}
               />
            </Col>
            <Col Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <TextField
                 fullWidth
                 id="other_addresss"
                 size="small"
                 label="Address"
                 variant="outlined"
                 placeholder="Address"
                 value={otherPartyDetails?.address}
                 onChange={(e) => {
                    setOtherPartyDetails((prevDetails)=> ({
                      ...prevDetails,
                      address: e.target.value
                    }))
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      otherAddress: '',
                    }))
                }}
                required
                error={errors?.otherAddress === "" ? false : true}
                helperText={errors?.otherAddress}
               />
            </Col>
            <Col Col xs={24} sm={12} md={8} lg={8} xl={8}>
            <TextField
                 fullWidth
                 id="other_damage"
                 size="small"
                 label="Damage to vehicle / Point of impact"
                 variant="outlined"
                 placeholder="Damage to vehicle / Point of impact"
                 value={otherPartyDetails?.damage}
                 onChange={(e) => {
                    setOtherPartyDetails((prevDetails)=> ({
                      ...prevDetails,
                      damage: e.target.value
                    }))
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      otherDamage: '',
                    }))
                }}
                required
                error={errors?.otherDamage === "" ? false : true}
                helperText={errors?.otherDamage}
               />
            </Col>
            </Row>
          </div>
          <div className="accident-box" style={{ marginTop: '20px'}}>
            <span className="accident-box-heading">Witness Details</span>
            
  <div className={classes.dataSheet}>
      <div >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <TextField
                 fullWidth
                 id="name_1"
                 size="small"
                 label="1-Witness Name"
                 variant="outlined"
                 placeholder="Enter Name"
                 value={witnessDetails?.witness_name_1}
                 onChange={(e) => {
                    setWitnessDetails((prevDetails)=> ({
                      ...prevDetails,
                      witness_name_1: e.target.value
                    }))
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        witnessOneName: '',
                      }))
                }}
                required
                error={errors?.witnessOneName === "" ? false : true}
                helperText={errors?.witnessOneName}
               />
          </Col>
          <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <TextField
                 fullWidth
                 id="contact_1"
                 size="small"
                 label="1-Contact Number"
                 variant="outlined"
                 placeholder="Enter Contact Number"
                 value={witnessDetails?.witness_contact_number_1}
                 onChange={(e) => {
                    setWitnessDetails((prevDetails)=> ({
                      ...prevDetails,
                      witness_contact_number_1: e.target.value
                    }))
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      witnessOneContact: '',
                    }))
                }}
                required
                error={errors?.witnessOneContact === "" ? false : true}
                helperText={errors?.witnessOneContact}
               />
          </Col>
          <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <TextField
                 fullWidth
                 id="address_1"
                 size="small"
                 label="1-Address"
                 variant="outlined"
                 placeholder="Enter Address"
                 value={witnessDetails?.witness_address_1}
                 onChange={(e) => {
                    setWitnessDetails((prevDetails)=> ({
                      ...prevDetails,
                      witness_address_1: e.target.value
                    }))
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      witnessOneContact: '',
                    }))
                }}
                error={errors?.witnessOneAddress === "" ? false : true}
                helperText={errors?.witnessOneAddress}
               />
          </Col>

          <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <TextField
                 fullWidth
                 id="name_2"
                 size="small"
                 label="2-Witness Name"
                 variant="outlined"
                 placeholder="Enter Name"
                 value={witnessDetails?.witness_name_2}
                 onChange={(e) => {
                    setWitnessDetails((prevDetails)=> ({
                      ...prevDetails,
                      witness_name_2: e.target.value
                    }))
                }}
               />
          </Col>
          <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <TextField
                 fullWidth
                 id="contact_2"
                 size="small"
                 label="2-Contact Number"
                 variant="outlined"
                 placeholder="Enter Contact Number"
                 value={witnessDetails?.witness_contact_number_2}
                 onChange={(e) => {
                    setWitnessDetails((prevDetails)=> ({
                      ...prevDetails,
                      witness_contact_number_2: e.target.value
                    }))
                }}
               />
          </Col>
          <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <TextField
                 fullWidth
                 id="address_2"
                 size="small"
                 label="2-Address"
                 variant="outlined"
                 placeholder="Enter Address"
                 value={witnessDetails?.witness_address_2}
                 onChange={(e) => {
                    setWitnessDetails((prevDetails)=> ({
                      ...prevDetails,
                      witness_address_2: e.target.value
                    }))
                }}
               />
          </Col>

          <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <TextField
                 fullWidth
                 id="name_3"
                 size="small"
                 label="3-Witness Name"
                 variant="outlined"
                 placeholder="Enter Name"
                 value={witnessDetails?.witness_name_3}
                 onChange={(e) => {
                    setWitnessDetails((prevDetails)=> ({
                      ...prevDetails,
                      witness_name_3: e.target.value
                    }))
                }}
               />
          </Col>
          <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <TextField
                 fullWidth
                 id="contact_3"
                 size="small"
                 label="3-Contact Number"
                 variant="outlined"
                 placeholder="Enter Contact Number"
                 value={witnessDetails?.witness_contact_number_3}
                 onChange={(e) => {
                    setWitnessDetails((prevDetails)=> ({
                      ...prevDetails,
                      witness_contact_number_3: e.target.value
                    }))
                }}
               />
          </Col>
          <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <TextField
                 fullWidth
                 id="address_3"
                 size="small"
                 label="3-Address"
                 variant="outlined"
                 placeholder="Enter Address"
                 value={witnessDetails?.witness_address_3}
                 onChange={(e) => {
                    setWitnessDetails((prevDetails)=> ({
                      ...prevDetails,
                      witness_address_3: e.target.value
                    }))
                }}
               />
          </Col>
          
        </Row>
        </div>
  </div>
</div>
        <div className="accident-box" style={{ marginTop: '15px'}}>
            <span className="accident-box-heading">Additional Info</span>
            <Row style={{ padding: '4px'}} gutter={[16,16]}>
                <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                <span style={{ fontWeight: 'bold'}}>Anyone Injured?</span>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                <Radio.Group onChange={(e) => {
                    setAnyInjury((prev)=>({
                        ...prev,
                        isInjured: e.target.value
                    }))
                }} value={anyInjury?.isInjured}>
                <Radio value={1}>Yes</Radio>
                <Radio value={2}>No</Radio>
                </Radio.Group>
                </Col>
                <Col xs={24} sm={12} md={8} lg={10} xl={16}>
                <TextArea
                 autoSize
                 onChange={(e) => {
                    setAnyInjury((prev)=>({
                        ...prev,
                        injuryNotes: e.target.value
                    }))
                    setErrors((prev) => ({
                      ...prev,
                      injuryNotes: ""
                    }))
                }}
                 value={anyInjury?.injuryNotes}
                 status={errors?.injuryNotes === "" ? "" : "error"}
                 />
                </Col>

            </Row>
            <Row style={{ padding: '4px'}} gutter={[16,16]}>
                <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                <span style={{ fontWeight: 'bold'}}>Property Damaged?</span>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                <Radio.Group
                onChange={(e) => {
                    setAnyDamage((prev)=>({
                        ...prev,
                        isDamaged: e.target.value
                    }))
                }}
                 value={anyDamage?.isDamaged}
                >
                <Radio value={1}>Yes</Radio>
                <Radio value={2}>No</Radio>
                </Radio.Group>
                </Col>
                <Col xs={24} sm={12} md={8} lg={10} xl={16}>
                <TextArea
                 onChange={(e) => {
                    setAnyDamage((prev)=>({
                        ...prev,
                        damageNotes: e.target.value
                    }))
                    setErrors((prev) => ({
                      ...prev,
                      damageNotes: ""
                    }))
                }}
                 value={anyDamage?.damageNotes}
                 status={errors?.damageNotes === "" ? "" : "error"}
                 autoSize/>
                </Col>

            </Row>
            <Row style={{ padding: '4px'}} gutter={[16,16]}>
                <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                <span style={{ fontWeight: 'bold'}}>Police Involved?</span>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={4}>
                <Radio.Group
                onChange={(e) => {
                    setPolice((prev)=>({
                        ...prev,
                        isPolice: e.target.value
                    }))
                }}
                 value={police?.isPolice}
                >
                <Radio value={1}>Yes</Radio>
                <Radio value={2}>No</Radio>
                </Radio.Group>
                </Col>
                <Col xs={24} sm={12} md={8} lg={10} xl={16}>
                <TextArea
                 onChange={(e) => {
                    setPolice((prev)=>({
                        ...prev,
                        policeNotes: e.target.value
                    }))
                    setErrors((prev) => ({
                      ...prev,
                      policeNotes: ""
                    }))
                }}
                 value={police?.policeNotes} 
                status={errors?.policeNotes === "" ? "" : "error"}
                 autoSize
                 />
                </Col>

            </Row>
             <Row style={{ padding: '4px' }} gutter={[16, 16]}>
            <Col xs={24} sm={12} md={8} lg={6} xl={4}>
              <span style={{ fontWeight: 'bold' }}>Was it a bridge strike?</span>
            </Col>
            <Col xs={24} sm={12} md={8} lg={6} xl={4}>
              <Radio.Group
                onChange={(e) => {
                  setBridgeStrike((prev) => ({
                    ...prev,
                    isStrike: e.target.value
                  }))
                }}
                value={bridgeStrike?.isStrike}
                
              >
                <Radio value={1}>Yes</Radio>
                <Radio value={2}>No</Radio>
              </Radio.Group>
            </Col>
            <Col xs={24} sm={12} md={8} lg={10} xl={16}>
              <TextArea
                onChange={(e) => {
                  setBridgeStrike((prev) => ({
                    ...prev,
                    strikeNotes: e.target.value
                  }))
                  setErrors((prev) => ({
                    ...prev,
                    strikeNotes: ""
                  }))
                }}
                status={errors?.strikeNotes === "" ? "" : "error"}
                value={bridgeStrike?.strikeNotes}
                
                autoSize
              />
            </Col>

          </Row>
           { bridgeStrike?.isStrike === 1 &&  <div>
          <UploadButton
            component="label"
            variant="contained"
            sx={{ marginTop: "10px" }}
            startIcon={<CloudUploadIcon />}
          >
            Add Strike files
            <input
              type="file"
              hidden
              multiple
              capture
             
              accept="image/*, video/*"
              onChange={(e) => {
                        handleSubmitImageBridge(e);
                      }}
            />
          </UploadButton>
        </div>}
         {currentItemFilesBridge?.length > 0 && <h4>Old Files:</h4>}
        <ul>
                  {currentItemFilesBridge?.length > 0 &&
                    currentItemFilesBridge
                      .filter(
                        (item) =>
                          !filesBridge.some((file) => file.name === item)
                      )
                      .map((item) => {
                        const encodedFileName = item.replace(/\+/g, '%2B');

                        return (
                          <li>
                           
                                <IconButton
                                  aria-label="delete"
                                  color="primary"
                                  onClick={() => handleDeleteCurrentFileBridge(item)}
                                >
                                  <DeleteIcon />
                                </IconButton>
                             

                            <a
                              href={`${config.tms_uploads_cdn}/${config.env}/accidents/${selectedRoute}/${item}`}
                              target="_blank"
                            >
                              {extractOriginalFileName(encodedFileName)}
                            </a>
                          </li>
                        );
                      })}
                </ul>
        <Divider />
        {filesBridge?.length > 0 && <h4>New Files:</h4>}
                <ul>
                  {filesBridge.length > 0 &&
                    filesBridge.map((file) => {
                      const encodedFileName = file?.name.replace(/\+/g, '%2B');
                      return (
                        <li>
                          {" "}
                          <IconButton
                            aria-label="delete"
                            color="primary"
                            onClick={() => deleteNormalFilesBridge(file.name)}
                          >
                            <DeleteIcon />
                          </IconButton>
                          {extractOriginalFileName(encodedFileName)}
                        </li>
                      );
                    })}
                </ul>
        </div>
        </Grid>

        <h4 style={{ fontWeight: "bold", marginBottom: "3px" }}>
          Additional Notes
        </h4>
        <div>
          <Row gutter={[16, 16]}>
            <Col xs={24} sm={12} md={12} lg={12} xl={12}>
              <TextArea
                autoSize={{ minRows: 3, maxRows: 6 }}
                label="Notes"
                placeholder="Enter Any Specific Notes"
                onChange={(e)=> setNotes(e.target.value)}
                value={notes}
              />
            </Col>
          </Row>
        </div>

        <Divider />
        <div>
                  <UploadButton
                    component="label"
                    variant="contained"
                    sx={{ marginTop: "10px" }}
                    startIcon={<CloudUploadIcon />}
                  >
                    Add files
                    <input
                      type="file"
                      hidden
                      multiple
                      capture
                      accept="image/*, video/*"
                      onChange={(e) => {
                        handleSubmitImage(e);
                      }}
                    />
                  </UploadButton>
                </div>
                {currentItemFiles?.length > 0 && <h4>Current Files:</h4>}
                <Image.PreviewGroup>
                  {currentItemFiles?.length > 0 &&
                    currentItemFiles
                      .filter((item) => !files.some((file) => file.name === item))
                      .map((item) => {
                        const imageUrl = `${config.tms_uploads_cdn}/${config.env}/accidents/${selectedRoute}/${item}`;
                        return (
                          <div
                            style={{
                              position: "relative",
                              marginRight: "10px",
                              display: "inline-block",
                            }}
                          >
                            <Image
                              width={200}
                              height={150}
                              style={{ padding: "5px", border: "1px solid lightgrey" }}
                              src={imageUrl}
                            />
                              <Tooltip title="Delete">
                                <CloseOutlined
                                  style={{
                                    fontSize: "30px",
                                    position: "absolute",
                                    right: 5,
                                    top: 5,
                                    color: "#c12828",
                                  }}
                                  onClick={() => handleDeleteCurrentFile(item)}
                                />
                              </Tooltip>
                          </div>
                        );
                      })}
                </Image.PreviewGroup>
                <Divider />
                {files?.length > 0 && <h4>New Files:</h4>}
                <Image.PreviewGroup>
                  {files?.length > 0 &&
                    files.map((files) => {
                      return (
                        <div
                          style={{
                            position: "relative",
                            marginRight: "10px",
                            display: "inline-block",
                          }}
                        >
                          <Image
                            width={200}
                            height={150}
                            style={{ padding: "5px", border: "1px solid lightgrey" }}
                            src={URL.createObjectURL(files.file)}
                          />
                          <Tooltip title="Delete">
                            <CloseOutlined
                              style={{
                                fontSize: "30px",
                                position: "absolute",
                                right: 5,
                                top: 5,
                                color: "#c12828",
                              }}
                              onClick={() => handleDeleteFile(files.name)}
                            />
                          </Tooltip>
                        </div>
                      );
                    })}
                </Image.PreviewGroup>

        <Grid item xs={12}>
          <Box style={{ float: "right", marginTop: "40px" }}>
          <AntButton
            onClick={() => navigate("/routes")}
            danger
            style={{ marginRight: "10px" }}
            size="large"
          >
            Cancel
          </AntButton>
          {/* <FormButton
            type="close"
            style={{ marginRight: "10px" }}
            onClick={() => {
              navigate("/routes");
            }}
          >
            Cancel
          </FormButton> */}
            <AntButton
              type="primary"
              size="large"
              onClick={handleSubmit}
            >
            Save
            </AntButton>
          </Box>
        </Grid>
        <Message type={type} msg={loadMessage} />
      </div>
    );
  };
  
  export default Index;
  